import { env } from '~~core';

import type { SerialSignature } from '../../composables/use-serial-signature';

export type SerialSignatureType = 'envelope' | 'batch';

type SerialSignatureConfig = {
  signatures: SerialSignature[];
  documentsSignedCount: number;
};

function buildEnvelopeURL(key: string) {
  return new URL(`/notarial/compat/requests/${key}`, env.TAVOLA_BASE_URL);
}

function buildBatchURL(key: string) {
  return new URL(`/sign/${key}`, env.TAVOLA_BASE_URL);
}

function withQueryParams(_url: URL) {
  const params = new URLSearchParams(window.location.search);
  const url = new URL(_url);

  const serialSignature = params.get('serial_signature');
  const fromSignerArea = params.get('from_signer_area');
  const exists = (value: string | null): value is 'true' => value === 'true';

  if (exists(serialSignature)) url.searchParams.set('serial_signature', serialSignature);
  if (exists(fromSignerArea)) url.searchParams.set('from_signer_area', fromSignerArea);

  return url;
}

const widgetUrlBuilder = {
  envelope: buildEnvelopeURL,
  batch: buildBatchURL,
};

export function buildWidgetURL(signature: SerialSignature) {
  const buildURLFor = widgetUrlBuilder[signature.type];
  const url = buildURLFor(signature.key);

  return withQueryParams(url);
}

export function minifySignatureConfig(config: SerialSignatureConfig) {
  return {
    c: config.documentsSignedCount,
    s: config.signatures.map((signature) => ({
      k: signature.key,
      c: signature.signableDocumentsCount,
      t: signature.type,
    })),
  };
}
